module.exports = __webpack_public_path__ + "static/gojek-7f1683685d06e7fdd1105bd4ffef9fbc.svg";